import { Component } from '@angular/core';
import { VTableService } from '@app/directives/_layout/v-table/_services/v-table.service';
import { SortDirection } from '@app/enum/SortDirection';
import { ContextualSpeedingOverrideService } from '@app/services/contextual-speeding-override.service';
import { UnitConversionService, UnitConversionType } from '@app/services/unitConversion.service';
import { ContextualSpeedingTab } from '../base/contextual-speeding-tab';
import { ContextualSpeedingRoadEditorComponent } from '../contextual-speeding-road-editor/contextual-speeding-road-editor.component';
import { ContextualSpeedingOverride } from '../models/contextual-speeding-override';
import './contextual-speeding-by-road.component.scss';

@Component({
    selector: 'contextual-speeding-by-road',
    template: require('./contextual-speeding-by-road.component.html')
})
export class ContextualSpeedingByRoadComponent 
    extends ContextualSpeedingTab<ContextualSpeedingOverride, ContextualSpeedingRoadEditorComponent> {
    constructor(
        public readonly vTableService: VTableService,
        private readonly overrideService: ContextualSpeedingOverrideService,
        private readonly unitConversionService: UnitConversionService,
    ) {
        super(vTableService);    
    }

    async loadData(): Promise<ContextualSpeedingOverride[]> {
        return await this.overrideService.getContextualSpeedingOverrides();
    }

    async deleteItem(item: ContextualSpeedingOverride): Promise<void> {
        await this.overrideService.deleteContextualSpeedingOverride(item.Id);
    }

    createTable(): void {
        this.columns = [
            {
                header: this.vTableService.createTableHeader({ tKey: "ContextualSpeedingByRoad.Name"}),
                createCellFunction: item => this.vTableService.createTableCell(item.Name)
            },
            {
               header: this.vTableService.createTableHeader({ tKey: "ContextualSpeedingByRoad.ReportedSpeedLimit", width: 170 }),
               createCellFunction: item => this.vTableService.createTableCell(this.getSpeedFormatted(item.ReportedSpeedKph))
            },
            {
               header: this.vTableService.createTableHeader({ tKey: "ContextualSpeedingByRoad.OverriddenSpeedLimit", width: 170 }),
               createCellFunction: item => this.vTableService.createTableCell(this.getSpeedFormatted(item.OverrideSpeedKph))
            },
            {
                header: this.vTableService.createTableHeader({ tKey: "ContextualSpeedingByRoad.Address" }),
                createCellFunction: item => this.vTableService.createTableCell(item.Address)
             },
            {
                header: this.vTableService.createDateTableHeader({ tKey: "ContextualSpeedingByRoad.LastUpdated", sorted: true, sortDirection: SortDirection.Descending }),
                createCellFunction: item => this.vTableService.createDateCell(item.UpdatedTime)
            },
            {
                header: this.vTableService.createDateTableHeader({ tKey: "ContextualSpeedingByRoad.Created" }),
                createCellFunction: item => this.vTableService.createDateCell(item.CreatedTime)
            },
        ]
    }

    private getSpeedFormatted(speed?: number): string {
        if (!speed || speed <= 0) {
            return "-";
        }

        return this.unitConversionService.convertToUserUnitWithLabel(
            speed, 
            UnitConversionType.Speed
        )
    }
}